import { FeatureName, FeatureStatus } from '@factoryfixinc/ats-interfaces';
import { useEmployerFeatureStore } from '../employer-feature/employer-feature.store';

export class EmployerFeatureGatingService {
  private store = useEmployerFeatureStore();

  // Golden Gate is used for better control over production deployments:
  // - When DISABLED: All features below are accessible to all users (default state)
  // - When ENABLED: Features become restricted and require explicit enablement per employer
  // This allows gradual rollouts and quick rollbacks without code changes
  private readonly gatedFeatures: FeatureName[] = [
    FeatureName.TALENT_POOL_UNLOCKS,
    FeatureName.INTERVIEW_SCHEDULING,
    FeatureName.LABOR_MARKET_REPORTS,
    FeatureName.MARKETABLE_CANDIDATE_REPORTS,
  ];

  public hasAccess(featureName: FeatureName): boolean {
    // If the feature is not in the gated features list, always allow access
    if (!this.gatedFeatures.includes(featureName)) {
      return true;
    }

    // Check if Golden Gate feature is enabled
    const goldenGateEnabled = this.store.employerFeatures.some(
      (feature) =>
        feature.featureName === FeatureName.GOLDEN_GATE &&
        feature.featureStatus === FeatureStatus.ENABLED,
    );

    if (!goldenGateEnabled) {
      return true;
    }

    // If Golden Gate is enabled, check if the specific gated feature is enabled
    const gatedFeature = this.store.employerFeatures.find(
      (feature) => feature.featureName === featureName,
    );

    // Only allow access if the feature exists AND is explicitly enabled
    return gatedFeature ? gatedFeature.featureStatus === FeatureStatus.ENABLED : false;
  }
}
